import { render, staticRenderFns } from "./BankList.vue?vue&type=template&id=1093a3cc&scoped=true&"
import script from "./BankList.vue?vue&type=script&lang=js&"
export * from "./BankList.vue?vue&type=script&lang=js&"
import style0 from "./BankList.vue?vue&type=style&index=0&id=1093a3cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1093a3cc",
  null
  
)

export default component.exports